import { Api } from "../config/request";

export default {
  getCampaignList(payload) {
    return Api.post("/campaigns/list", payload);
  },
  getCampaignCities(payload) {
    return Api.post("/campaigns/mappings", payload);
  },
  updateCampaign(payload) {
    return Api.post("/campaigns/upsert", payload);
  },
};
